import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarMapeosClaveCuenta,
  type ListarMapeosParams,
} from "../services/mapeos-clave-cuenta-service";

/**
 * Listado PAGINADO server-side · query options compartidas entre el loader del
 * route y el componente. La key extiende `qk.adminMapeosClaveCuenta` para que
 * los invalidate de las mutations sigan alcanzando por prefijo.
 */
export const mapeosClaveCuentaQueryOptions = (params: ListarMapeosParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminMapeosClaveCuenta, "paginado", params] as const,
    queryFn: () => listarMapeosClaveCuenta(params),
    placeholderData: keepPreviousData,
  });

export function useMapeosClaveCuenta(params: ListarMapeosParams = {}) {
  return useQuery(mapeosClaveCuentaQueryOptions(params));
}
